import Vue from 'vue';
import Vuex from 'vuex';
import user from "./modules/user";
import parameters from "./modules/parameters";
// import auth from './modules/auth';
import app from "./modules/app";
import tagsView from "./modules/tagsView";
import permission from "./modules/permission";
import customer from "./modules/customer";
import getters from "./getters";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    parameters: parameters,
    user: user,
    tagsView: tagsView,
    permission: permission,
    customer: customer
    // auth,
  },
  getters: getters
});
export default store;